import Evaluaciones from "pages/LandingPages/Evaluaciones/evaluaciones";

export default function EvaluacionesPage() {
  return <Evaluaciones />;
}
